<div
  #container
  class="flex justify-center mt-2 cropper-container"
  data-zoom-ignore="true"
></div>
